export const hideYotpoSlider = {
    key: "hide-yotpo-slider",
    init: (value) => {
        if(value) {
            const styleEl = document.createElement("style");
            styleEl.id = "hide-yotpo-slider-style"
            // Append <style> element to <head>
            document.head.appendChild(styleEl);
            // Grab style element's sheet
            const styleSheet = styleEl.sheet;
            styleSheet.insertRule(".yotpo-pictures-widget{display:none;}", 0)
        }else{
            const styleEl = document.getElementById("hide-yotpo-slider-style");
            if(styleEl){
                styleEl.remove();
            }
        }
    }
}